import { useSelector } from 'react-redux';

import { Grid, Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { RootState } from 'src/redux/reducer';

import Style from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

type Props = {
  button: React.ReactNode;
};

const SearchNotFound = ({ button }: Props) => {
  const { t } = useTranslation('common');
  const { courseApiQueries }: any = useSelector((state: RootState) => ({
    courseApiQueries: state.Course.get('courseApiQueries'),
  }));

  return (
    <Style container>
      <Grid item xs>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }}>
          <FontAwesomeIcon icon="fa-light fa-telescope" />
        </Box>
        <Typography className="title" variant="h4" component="div">
          <b>{t('search_course.course_not_found.title', { search_keyword: courseApiQueries.q })}</b>
        </Typography>
        <Typography className="description" variant="subtitle1" component="div">
          {t('search_course.course_not_found.desc')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: 2 }}>{button}</Box>
      </Grid>
    </Style>
  );
};

export default SearchNotFound;
